import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function TurnRightIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 13, 13);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 13 13" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M0.5 12.5V11.45C0.5 8.92976 0.5 7.66965 0.990471 6.70704C1.4219 5.86031 2.11031 5.1719 2.95704 4.74047C3.91965 4.25 5.17976 4.25 7.7 4.25H12.5M12.5 4.25L8.75 8M12.5 4.25L8.75 0.5" /></svg>
  );
}

export default TurnRightIcon;